import { createAsyncThunk } from '@reduxjs/toolkit';
import { wpBase, mcBase } from '../api/base';

////////////////WP REST API////////////////

// FETCH VEHICLES
const fetchWpCars = createAsyncThunk(
  'cars/fetch',
  async ({ pageKeyWp, category }) => {
    const response = await wpBase.get(
      `/wp-json/wp/v2/hp_listing?hp_listing_category=${category}&page=${pageKeyWp}&per_page=100`
    );
    return response;
  }
);

// FETCH VEHICLE DETALS
const fetchWpCarDetails = createAsyncThunk(
  'carsDetails/fetch',
  async (carId) => {
    const response = await wpBase.get(`/wp-json/wp/v2/hp_listing/${carId}`);
    return response;
  }
);

// FETCH VENDORS
const fetchWpVendors = createAsyncThunk('vendors/fetch', async (vendorId) => {
  const response = await wpBase.get(`/wp-json/wp/v2/hp_vendor/${vendorId}`);
  return response;
});

////////////////THIRD PARTY API////////////////

// FETCH CARS/TRUCKS
const fetchMcCars = createAsyncThunk('vehicleMc/fetch', async (params) => {
  const {
    pageKeyMc = '',
    lat = '',
    lng = '',
    radius = '',
    make = '',
    model = '',
    priceVal = [],
    yearVal = [],
    milesVal = [],
    condition = '',
    horsepowerVal = '',
    engineSizeVal = '',
    lengthVal = '',
    extColors = [],
    intColors = [],
    transmission = [],
    drive = [],
    engine = [],
    body = [],
    fuel = [],
    premium_features = [],
    seller = '',
    cleanTitle = '',
    otherApiCategory = '',
  } = params;

  console.log(premium_features);

  // START
  const start = `&start=${(pageKeyMc - 1) * 28}&rows=28`;

  // LOCATION
  const showLocation = lat !== '' ? `&latitude=${lat}&longitude=${lng}` : '';

  // RADIUS
  const showRadius = radius !== '' ? `&radius=${radius}` : '';

  // MAKE
  const showMake = make !== '' ? `&make=${make}` : '';

  // MODEL
  const showModel = model !== '' ? `&model=${model}` : '';

  // PRICE
  const priceMin = priceVal[0];
  const priceMax = priceVal[1];
  const showPrice =
    priceVal.length > 0 ? `&price_range=${priceMin}-${priceMax}` : '';

  // YEAR
  const yearMin = yearVal[0];
  const yearMax = yearVal[1];
  const showYear =
    yearVal.length > 0 ? `&year_range=${yearMin}-${yearMax}` : '';

  // MILES
  const milesMin = milesVal[0];
  const milesMax = milesVal[1];
  const showMiles =
    milesVal.length > 0 ? `&miles_range=${milesMin}-${milesMax}` : '';

  // CONDITION
  let showCondition = '';

  if (
    otherApiCategory === 'motorcycle' ||
    otherApiCategory === 'rv' ||
    otherApiCategory === 'heavy-equipment'
  ) {
    showCondition =
      condition === true ? '&inventory_type=new' : '&inventory_type=used';
  } else {
    showCondition = condition === true ? '&car_type=new' : '&car_type=used';
  }

  // EXTERIOR COLOR
  let showExtColor = '';

  if (otherApiCategory === 'motorcycle') {
    showExtColor = extColors.length > 0 ? `&color=${extColors.toString()}` : '';
  } else if (otherApiCategory === 'rv') {
    showExtColor =
      extColors.length > 0 ? `&exterior_color=${extColors.toString()}` : '';
  } else {
    showExtColor =
      extColors.length > 0
        ? `&base_exterior_color=${extColors.toString()}`
        : '';
  }

  // INTERIOR COLOR
  let showIntColor = '';

  if (otherApiCategory === 'rv') {
    showIntColor =
      intColors.length > 0 ? `&interior_color=${intColors.toString()}` : '';
  } else {
    showIntColor =
      intColors.length > 0
        ? `&base_interior_color=${intColors.toString()}`
        : '';
  }

  // TRANSMISSION
  const showTrans =
    transmission.length > 0 ? `&transmission=${transmission.toString()}` : '';

  // DRIVE
  const showDrive = drive.length > 0 ? `&drivetrain=${drive.toString()}` : '';

  // ENGINE
  const showEngine = engine.length > 0 ? `&cylinders=${engine.toString()}` : '';

  // BODY
  const showBody = body.length > 0 ? `&body_type=${body.toString()}` : '';

  // FUEL
  const showFuel = fuel.length > 0 ? `&fuel_type=${fuel.toString()}` : '';

  // PREMIUM FEATURES
  const featureMappings = {
    'Sun Roof/Moon Roof': 'sun/moonroof',
    'Parking Sensor': 'parking distance sensors',
    'Blind Spot Monitoring': 'blind spot system',
    '3rd Row Seating': '3rd row seats',
    CarPlay: 'apple carplay',
    'Alloy Wheels': 'premium wheels',
  };

  const showPremFeatures =
    premium_features.length > 0
      ? `&high_value_features=${premium_features
          .map((feature) =>
            featureMappings[feature] // Replace if found in mapping
              ? featureMappings[feature].toLowerCase()
              : feature.toLowerCase()
          )
          .join(',')}&facets=high_value_features`
      : '';

  // SELLER
  const showSeller =
    seller === true ? '&dealer_type=independent' : '&dealer_type=franchise';

  // TITLE
  const showCleanTitle = cleanTitle === true ? `&carfax_clean_title=true` : '';

  const response = await mcBase.get(
    `/v2/search/${otherApiCategory}/active?api_key=${process.env.REACT_APP_MC_API_KEY}${start}${showLocation}${showRadius}${showModel}${showMake}${showPrice}${showYear}${showMiles}${showCondition}${showExtColor}${showIntColor}${showTrans}${showDrive}${showEngine}${showBody}${showFuel}${showPremFeatures}${showSeller}${showCleanTitle}`
  );
  return response;
});

// FETCH CARS/TRUCKS DETALS & VENDORS
const fetchMcCarDetails = createAsyncThunk(
  'mcCarsDetails/fetch',
  async (carId) => {
    const response = await mcBase.get(
      `/v2/listing/car/${carId}?api_key=${process.env.REACT_APP_MC_API_KEY}`
    );
    return response;
  }
);

export {
  fetchWpCars,
  fetchWpCarDetails,
  fetchMcCars,
  fetchMcCarDetails,
  fetchWpVendors,
};
